import { render, staticRenderFns } from "./producer_dashboard.vue?vue&type=template&id=5c41295e&scoped=true"
import script from "./producer_dashboard.vue?vue&type=script&lang=js"
export * from "./producer_dashboard.vue?vue&type=script&lang=js"
import style0 from "./producer_dashboard.vue?vue&type=style&index=0&id=5c41295e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41295e",
  null
  
)

export default component.exports